import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";

export const branchesSetData = (branches) => {
  return {
    type: actionType.BRANCHES_SET_DATA,
    branches: branches,
  };
};

export const branchesFailData = (error) => {
  return {
    type: actionType.BRANCHES_FAIL_DATA,
    error: error,
  };
};

export const branchesLoading = () => {
  return {
    type: actionType.BRANCHES_LOADING,
  };
};

export const branchesGetData = () => {
  return (dispatch) => {
    dispatch(branchesLoading());
    axios
      .get(baseUrl + "/branches", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(branchesSetData(res.data));
      })
      .catch((error) => dispatch(branchesFailData(error)));
  };
};

export const deleteBranchesFail = (error) => {
  return {
    type: actionType.DELETE_BRANCHES_FAIL,
    error: error,
  };
};

export const deleteBranches = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/branches/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(branchesGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deleteBranchesFail()));
    }
  };
};

export const postBranchesDataStart = () => {
  return {
    type: actionType.POST_BRANCHES_DATA_START,
  };
};

export const postBranchesDataFail = (error) => {
  return {
    type: actionType.POST_BRANCHES_DATA_FAIL,
    error: error,
  };
};

export const postBranchesDataSuccess = (success) => {
  return {
    type: actionType.POST_BRANCHES_DATA_SUCCESS,
    success: success,
  };
};

export const branchesPostLoading = () => {
  return {
    type: actionType.BRANCHES_POST_LOADING,
  };
};

export const postBranchesData = (data, branches, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(postBranchesDataStart());
    dispatch(branchesPostLoading());
    axios
      .post(baseUrl + "/branches", branches, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postBranchesDataSuccess(res.data));
        dispatch(branchesGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Created",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postBranchesDataFail(error));
      });
  };
};

export const updateBranchesDataStart = () => {
  return {
    type: actionType.UPDATE_BRANCHES_DATA_START,
  };
};

export const branchesUpdateLoading = () => {
  return {
    type: actionType.BRANCHES_UPDATE_LOADING,
  };
};

export const updateBranchesDataFail = (error) => {
  return {
    type: actionType.UPDATE_BRANCHES_DATA_FAIL,
    error: error,
  };
};

export const updateBranchesDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_BRANCHES_DATA_SUCCESS,
    success: success,
  };
};

export const updateBranchesData = (data, branches, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(updateBranchesDataStart());
    dispatch(branchesUpdateLoading()); 

    axios
      .put(baseUrl + `/branches/${data.id}`, branches, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updateBranchesDataSuccess(res.data));
        dispatch(branchesGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updateBranchesDataFail(error));
      });
  };
};
